export function getdata() {
	var obj = {
		headDatachoose: [{
			title: "序号",
			prop: "index",
			custom: true,
			width: "80"
		},
		{
			title: "公司代码",
			prop: "companyCode",
			width: "80"
		},
		{
			title: "纳税人（公司）名称",
			prop: "nsrmc",
			width: 160,

		},
		{
			title: "纳税人识别号",
			prop: "nsrsbh",
			width: 160,

		},
		],
		headData: [{
			title: "公司名称",
			width: "200",
			prop: 'companyName',
			custom: true,

		},
		{
			title: "增值税执行差异",
			width: "80", custom: true,
			prop: 'stx'
		},
		{
			title: "计算公式",
			width: "180", custom: true,
			prop: 'jsgs'
		},
		{
			title: "增值税税基(实际、含税)",
			children: [{
				title: "本期",
				width: "80", custom: true,
				prop: "zengzssjSjbq",
				AmountFormat: true,

			},
			{
				title: "累计",
				width: "80", custom: true,
				prop: "zengzssjSjlj",
				AmountFormat: true,

			}
			]
		},
		{
			title: "增值税税基(标准、含税)",
			children: [{
				title: "本期",
				width: "80", custom: true,
				prop: "zengzssjBzbq",
				AmountFormat: true,

			},
			{
				title: "累计",
				width: "80", custom: true,
				prop: "zengzssjBzlj",
				AmountFormat: true,

			}
			]
		},
		{
			title: "正差",
			children: [{
				title: "本期",
				width: "80", custom: true,
				prop: "zhengcbq",
				AmountFormat: true,

			},
			{
				title: "累计",
				width: "80", custom: true,
				prop: "zhengclj",
				AmountFormat: true,

			}
			]
		},
		{
			title: "负差",
			children: [{
				title: "本期",
				width: "80", custom: true,
				prop: "fucbq",
				AmountFormat: true,

			},
			{
				title: "累计",
				width: "80", custom: true,
				prop: "fuclj",
				AmountFormat: true,

			}
			]
		},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
